import React from 'react';
import PropTypes from 'prop-types';
import { Modal, Button } from 'antd';
import { DownloadOutlined } from '@ant-design/icons';
import styled from 'styled-components';

const StyledModal = styled(Modal)`
	.ant-modal-content {
		border-radius: 4px;
	}
	.ant-modal-body {
		padding: 24px;
		max-height: 80vh;
		overflow-y: auto;
	}
`;

const ButtonContainer = styled.div`
	display: flex;
	justify-content: flex-end;
	gap: 12px;
	margin-top: 24px;
	padding-top: 16px;
	border-top: 1px solid #f0f0f0;
`;

const CancelButton = styled(Button)`
	border: 1px solid #143e60;
	color: #143e60;
	background: #ffffff;
	&:hover {
		border-color: #1a4d7a;
		color: #1a4d7a;
		background: #ffffff;
	}
`;

const DownloadButton = styled(Button)`
	background: #143e60;
	color: #ffffff;
	border: none;
	&:hover {
		background: #1a4d7a;
		color: #ffffff;
	}
`;

const InvoiceInfo = styled.div`
	margin-bottom: 16px;
	padding: 10px 12px;
	background: #f5f5f5;
	border-radius: 4px;
	display: flex;
	justify-content: space-between;
	align-items: center;
`;

const InfoLabel = styled.span`
	font-weight: 500;
	color: #595959;
`;

const InfoValue = styled.span`
	color: #000;
	font-weight: 400;
`;

function ProformaPdfViewerModal({ visible, onClose, viewUrl, invoiceNumber, pdfFilename }) {
	const handleDownload = () => {
		if (viewUrl) window.open(viewUrl, '_blank');
	};

	return (
		<StyledModal
			title="Proforma Invoice"
			open={visible}
			onCancel={onClose}
			footer={null}
			width={800}
			centered
			destroyOnClose
			maskClosable={false}
		>
			{invoiceNumber && (
				<InvoiceInfo>
					<InfoLabel>Proforma Invoice Number:</InfoLabel>
					<InfoValue>{invoiceNumber}</InfoValue>
				</InvoiceInfo>
			)}

			{viewUrl ? (
				<>
					<div style={{ marginBottom: '12px', textAlign: 'center' }}>
						<p style={{ color: '#666', marginBottom: '8px' }}>
							For better PDF viewing experience, use the button below.
						</p>
						<Button
							type="primary"
							onClick={() => window.open(viewUrl, '_blank')}
							style={{ background: '#143e60', borderColor: '#143e60' }}
						>
							Open PDF in New Tab
						</Button>
					</div>
					<div style={{ border: '1px solid #d9d9d9', borderRadius: '6px' }}>
						<iframe
							title={invoiceNumber || 'Proforma Invoice'}
							src={`${viewUrl}#toolbar=0&navpanes=0&scrollbar=0`}
							width="100%"
							height="500"
							style={{ border: 'none', display: 'block' }}
						/>
					</div>
				</>
			) : (
				<div style={{ textAlign: 'center', padding: '40px 20px', color: '#999' }}>
					{pdfFilename || 'PDF'} — Preview not available
				</div>
			)}

			<ButtonContainer>
				<CancelButton onClick={onClose}>Cancel</CancelButton>
				<DownloadButton icon={<DownloadOutlined />} onClick={handleDownload}>
					Download
				</DownloadButton>
			</ButtonContainer>
		</StyledModal>
	);
}

ProformaPdfViewerModal.propTypes = {
	visible: PropTypes.bool.isRequired,
	onClose: PropTypes.func.isRequired,
	viewUrl: PropTypes.string,
	invoiceNumber: PropTypes.string,
	pdfFilename: PropTypes.string,
};

export default ProformaPdfViewerModal;
